import React from "react"; // useEffect removed - Razorpay payment disabled
import { useNavigate } from "react-router-dom";
import "../styles/Admission.css";

const gurukuls = [
  {
    name: "Shri Kheteshwar Gurukul, Mayalawas",
    image: "/mayalawas.jpg",
    link: "/gurukul/mayalawas-gurukul",
    classes: ["Grade 4", "Grade 5", "Grade 6", "Grade 7", "Grade 8", "Grade 9"],
    boarding: "🏠 Hostel Facility Available",
  },
  {
    name: "Shri Kheteshwar Gurukul, Bijrol Kheda",
    image: "/khedaadmission.jpg",
    link: "/gurukul/bijrol-kheda-gurukul",
    classes: ["Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6", "Grade 7", "Grade 8"],
    boarding: "🏠 Hostel Facility Available",
  },
  {
    name: "Shri Kheteshwar Gurukul, Sayala",
    image: "/sayala.jpg",
    link: "/gurukul/sayala-gurukul",
    classes: ["Arun Class", "Uday Class", "Prabhat Class", "Prathama Class", "Dvitheeya Class", "Triteeya Class", "Chaturthi Class", "Panchami Class"],
    boarding: "🚍 Day Boarding (Transportation Facility)",
  },
  {
    name: "Shri Kheteshwar Gurukul, Savai Chhoti",
    image: "/sawaichotiadmission.jpg",
    link: "/gurukul/sawai-choti-gurukul",
    classes: ["Arun Class", "Uday Class", "Prabhat Class", "Prathama Class", "Dvitheeya Class", "Triteeya Class", "Chaturthi Class", "Panchami Class"],
    boarding: "🚍 Day Boarding (Transportation Facility)",
  },
  {
    name: "Shri Kheteshwar Gurukul, Raithal (Jalore)",
    image: "/raithal1.jpg",
    link: "/gurukul/raithal-gurukul",
    classes: ["Primary Level"],
    boarding: "🚍 Day Boarding",
  },
];

const Admission = () => {
  const navigate = useNavigate();


  return (
    <div className="admission-containera">
      {/* 🔹 Notification Banner */}
      <div className="admission-notification1" onClick={() => navigate("/admissionForm")}>
        🎉 Hurry! Admissions are open for 2026-27. Register & Pay Application Fees to Confirm Your Seat!
      </div>
      
      <h1 className="admission-titlea">Welcome to Shri Kheteshwar Gurukul</h1>
      <p className="admission-subtitlea">A Blend of Ancient Indian Education and Modern Excellence</p>

      <p className="admission-texta">
        <strong>At Shri Kheteshwar Gurukul</strong>, we integrate Vedic knowledge with modern education. Here, 
        <strong> culture, ethics</strong>, and <strong>modern science</strong> come together uniquely.
      </p>

      <p className="admission-highlighta">
        <strong>Amazing fusion of ancient and modern education</strong> <br />
        <strong>Special focus on values, ethics, and self-reliance</strong> <br />
        <strong>Gurukul system with modern facilities</strong> – Education with proper guidance <br />
        <strong>An ideal environment</strong> for holistic development
      </p>

      {/* Gurukul Display */}
      <div className="gurukul-lista">
        {gurukuls.map((gurukul, index) => (
          <div key={index} className="gurukul-carda" onClick={() => navigate(gurukul.link)}>
            <img src={gurukul.image} alt={gurukul.name} className="gurukul-imagea" />
            <h2 className="gurukul-namea">{gurukul.name}</h2>
            <p className="gurukul-classesa"><strong>Grades:</strong> {gurukul.classes.join(", ")}</p>
            <p className="gurukul-boardinga">{gurukul.boarding}</p>
          </div>
        ))}
      </div>

      {/* Information Section */}
      <div className="info-sectiona">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>📖 Comprehensive education system blending tradition & modernity</li>
          <li>🏆 Focus on discipline, values, and ethics</li>
          <li>🎓 Experienced faculty guiding students to excellence</li>
          <li>🌿 Beautiful & peaceful campus for better learning</li>
          <li>📚 Well-equipped libraries, labs & sports facilities</li>
        </ul>
      </div>

      {/* Video Section */}
      <div className="video-sectiona">
        <h2>Explore Our Gurukul</h2>
        <div className="video-containera">
          <video id="gurukul-videoa" className="gurukul-videoa" controls>
            <source src="/mayalawasF.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* Admission Form Section */}
      <div className="admission-form-sectionAA">
        <h2 className="admission-titleAA">🎓 Admission Open for Session 2026-27</h2>
        <p className="admission-subtitleAA">Apply now and become a part of our esteemed Gurukul.</p>

        {/* Application Form Link */}
        <div className="cta-containerAA">
          <a href="/admissionForm" className="apply-btnAA">📌 Apply Now</a>
        </div>

        <p className="noteAA">
          📢 <strong>Note:</strong> The application form will be accepted only after the application fee is paid.
        </p>

      </div>



      <p className="admission-contacta">
        📞 <strong>9492821008, 9951615155, 9160221008, 9603551008 </strong> | ✉️ <strong>kheteshwargurukul1@gmail.com</strong>
      </p>
    </div>
  );
};

export default Admission;
